import api from "@/api";

const state = {
  accounts: []
};

// getters
const getters = {};

// mutations
const mutations = {
  setAccounts(state, data) {
    state.accounts = data;
  }
};

// actions
const actions = {
  getAllAccounts({ commit }) {
    return new Promise((resolve, reject) => {
      api
        .get("accounts", {
          params: { limit: 100, sort: "number" }
        })
        .then(res => {
          let accountsData = res.data;
          // console.log("res.data", res.data, "accountsData", accountsData);
          commit("setAccounts", accountsData);
          resolve(res);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
